import React from 'react';
import { connect } from 'react-redux';
import BlitzDefaultContent from './BlitzDefault.content';
import StealthSI01 from './Stealth-SI-01';
import PeoplesSI01 from './PeoplesSI01';
import MotoTruck from './MotoTruckTemplate';
import BlitzDefaultContentCustom from './BlitzDefaultCustom.content';
import { getSubSetting } from '../../../Utils/Common';

function SalesOrderCustomTemplate({ single_sales_order, auth, componentRef }) {
    const subs_setting = getSubSetting();
    const template_label = single_sales_order.template_setting
        ? single_sales_order.template_setting.template_label
        : 'none';

    return (
        <>
            {(() => {
                switch (template_label) {
                    case 'blitz_default':
                        return (
                            <>
                                <BlitzDefaultContent
                                    subs_setting={subs_setting}
                                    so={single_sales_order}
                                    auth={auth}
                                    print="0"
                                    print_rows="5"
                                />
                                <div style={{ display: 'none' }}>
                                    <BlitzDefaultContent
                                        subs_setting={subs_setting}
                                        so={single_sales_order}
                                        auth={auth}
                                        ref={componentRef}
                                        print="1"
                                        print_rows="19"
                                    />
                                </div>
                            </>
                        );
                    case 'blitz_default_custom':
                        return (
                            <>
                                <BlitzDefaultContentCustom
                                    subs_setting={subs_setting}
                                    so={single_sales_order}
                                    auth={auth}
                                    print="0"
                                    print_rows="5"
                                />
                                <div style={{ display: 'none' }}>
                                    <BlitzDefaultContentCustom
                                        subs_setting={subs_setting}
                                        so={single_sales_order}
                                        auth={auth}
                                        ref={componentRef}
                                        print="1"
                                        print_rows="19"
                                    />
                                </div>
                            </>
                        );
                    case 'stealth_si_01':
                        return (
                            <>
                                <StealthSI01
                                    subs_setting={subs_setting}
                                    so={single_sales_order}
                                    auth={auth}
                                    print="0"
                                    print_rows="5"
                                />
                                <div style={{ display: 'none' }}>
                                    <StealthSI01
                                        subs_setting={subs_setting}
                                        so={single_sales_order}
                                        auth={auth}
                                        ref={componentRef}
                                        print="1"
                                        print_rows="19"
                                    />
                                </div>
                            </>
                        );
                    case 'peoples_si_01': // since this template is almost the same i just change some text using varaibles
                    case 'peoples_si_02':
                        return (
                            <>
                                <PeoplesSI01
                                    subs_setting={subs_setting}
                                    so={single_sales_order}
                                    auth={auth}
                                    print="0"
                                    print_rows="5"
                                />
                                <div style={{ display: 'none' }}>
                                    <PeoplesSI01
                                        subs_setting={subs_setting}
                                        so={single_sales_order}
                                        auth={auth}
                                        ref={componentRef}
                                        print="1"
                                        print_rows="19"
                                    />
                                </div>
                            </>
                        );
                    case 'mototruck':
                        return (
                            <>
                                <MotoTruck
                                    subs_setting={subs_setting}
                                    so={single_sales_order}
                                    auth={auth}
                                    print="0"
                                    print_rows="5"
                                />
                                <div style={{ display: 'none' }}>
                                    <MotoTruck
                                        subs_setting={subs_setting}
                                        so={single_sales_order}
                                        auth={auth}
                                        ref={componentRef}
                                        print="1"
                                        print_rows="19"
                                    />
                                </div>
                            </>
                        );

                    default:
                        return (
                            <>
                                <h4 className="text-center my-5">
                                    -- There's No Data To Show--
                                </h4>
                            </>
                        );
                }
            })()}
        </>
    );
}

const mapStateToProps = (state) => ({
    auth: state.auth,
    single_sales_order: state.sales_order.single_sales_order,
});

export default connect(mapStateToProps, {})(SalesOrderCustomTemplate);
